import primaryComponents from "../../../primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useSelector } from "react-redux";

export const MarketPlaceCreation = ({
  isEditMode = false,
  rootFormDetails = {},
  setRootFormDetails = () => {},
}) => {
  const { has_squareup_connection } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <>
      {has_squareup_connection && !isEditMode ? (
        <section className={`${globalStyles.cardWithBackground} mt-4`}>
          <h5 className="mb-0">Create on third party platforms </h5>
          <p className="small-text-size mb-3" style={{ maxWidth: "700px" }}>
            Select the platforms you will like to auto create this product in,
            note that this creation would only work if the store is mapped to a
            third party store{" "}
          </p>

          <primaryComponents.Checkbox
            name="marketplaceCreation"
            id={"SQUAREUP"}
            isChecked={rootFormDetails?.auto_create_product_on_squareup}
            onChange={() =>
              setRootFormDetails((prev) => ({
                ...prev,
                auto_create_product_on_squareup:
                  !rootFormDetails?.auto_create_product_on_squareup,
              }))
            }
          >
            <span className="d-block mt-1">Create on Squareup</span>
          </primaryComponents.Checkbox>
        </section>
      ) : null}
    </>
  );
};
